import { useEffect } from 'react';
import { initializeSnowplowTracker } from 'src/analytics';

import type { FC, PropsWithChildren } from 'react';

function withSnowplowTracking(Component: FC<any>) {
  return function WrappedComponent(props: PropsWithChildren<any>) {
    useEffect(() => {
      initializeSnowplowTracker();
    }, []);

    return <Component {...props} />;
  };
}

export default withSnowplowTracking;
